export enum itemsListFilters {
    subCategories = 'subCategories',
    statuses = 'statuses',
    online = 'onlineStatuses',
    shipping = 'shipping',
    categories = 'categories',
    storages = 'storages',
    commissionStatuses = 'commissionStatuses',
}
